<template>
  <div class="vcv-layout">
    <router-view name="rates_informer" />

    <router-view name="header" :class="{ is_admin: isAdmin }" />

    <div class="vcv-layout__content">
      <router-view name="header_form" />

      <router-view class="content" />
    </div>

    <router-view name="footer" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Axios from 'axios';
import injectComponentDependency from '@/_helpers/injector.js';

export default {
  name: 'VcvLayout',

  computed: {
    ...mapState('locale', { locale: 'value' }),

    isPublicResponse() {
      return this.$route.meta ? this.$route.meta.public_response : null;
    },

    isAdmin() {
      return this.$route.meta ? this.$route.meta.is_admin : null;
    },

    isOnlineInterview() {
      return this.$route.meta ? this.$route.meta.online_interview : false;
    }
  },

  async created() {
    if (this.$route.name !== 'registration') {
      this.setTitle(this.$route);
    }

    Axios.defaults.headers.common['Accept-Language'] = this.locale;

    this.$store.dispatch('siteinformers/load').then(() => {
      if (this.$route.name === 'open-registration' || this.$route.name === 'interview') {
        this.$store.commit('siteinformers/set_messages', []);
      }
    });
  },

  methods: {
    injectDependencies() {
      injectComponentDependency();
    },

    setTitle(val) {
      this.$store.commit('updatePageStatus', null);

      let title = this.$tr('pageTitles.prefix');

      if (val && val.meta && val.meta.title) {
        let routeTitle = this.$tr(val.meta.title);

        title = `${routeTitle} - ${title}`;
      }

      document.title = title;
    }
  }
};
</script>

<style lang="scss" src="@/styles/base.scss"></style>
<style src="@/assets/styles/video.css" />

<style lang="scss" scoped>
.vcv-layout {
  background: $background;
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  &__content {
    flex: 1;
  }

  @media screen and (max-width: 680px) {
    overflow-x: scroll;
  }
}
</style>
